import type {
  OverrideReportConfigTemplateFieldValue,
  OverrideReportingSessionTemplateTransactionSortBy,
} from '../../contracts/reporting-api/document/override';

export interface OverrideReportTemplateFormData {
  id?: number | null;
  reportTitle?: string | null;
  reportSubtitle?: string | null;
  overrideSummaryHeader?: string | null;
  startDate?: string | Date | null;
  endDate?: string | Date | null;
  adjustment?: number | null;
  /** @deprecated Built-in override templates retain this legacy presentation setting. */
  showNtpSeparately?: boolean | null;
  hideTransactionList?: boolean | null;
  sortBy?: OverrideReportingSessionTemplateTransactionSortBy | null;
  displayFields?: string[];
  assignmentIds?: number[];
  existingFields?: OverrideReportTemplateField[];
}

export interface OverrideReportTemplateGridRow {
  id: number;
  /** Mirrors OverrideTemplateRecord.reportType so grids can branch without a second lookup. */
  reportType?: string | null;
  name: string;
  reportSubtitle?: string | null;
  assignmentCount: number;
  fields: OverrideReportTemplateField[];
  enabled?: boolean;
  createdAt?: string | null;
}

export interface OverrideReportTemplateOption {
  name: string;
  value: number;
}

export interface OverrideReportTemplateField {
  key: string;
  value: OverrideReportConfigTemplateFieldValue;
  editable: boolean;
}

export interface OverrideTemplateConfig {
  fields?: OverrideReportTemplateField[];
}

export interface OverrideTemplateRecord {
  id: number;
  /**
   * Non-null only for reports the system builds itself rather than ones an operator configured.
   * Those have no agency mapping and a fixed layout, so the UI treats them differently.
   */
  reportType?: string | null;
  name?: string | null;
  createdAt?: string | null;
  data?: OverrideTemplateConfig | null;
  mappings?: OverrideAssignmentRow[];
  enabled?: boolean;
}

export interface OverrideTemplatesResponse {
  data?: OverrideTemplateRecord[];
  totalCount?: number;
}

export interface OverrideAssignmentRow {
  id: number;
  display_name?: string | null;
  transactions_of?: string | null;
}

export interface OverrideAssignmentsResponse {
  data?: OverrideAssignmentRow[];
  mappings?: OverrideAssignmentRow[];
}

export const OVERRIDE_REPORT_TEMPLATE_FIELD_KEYS = {
  reportTitle: 'header.title',
  reportSubtitle: 'header.subtitle',
  overrideSummaryHeader: 'header.summaryHeading',
  startDate: 'request.startDate',
  endDate: 'request.endDate',
  adjustment: 'request.adjustment',
  hideTransactionList: 'presentation.hideTransactionList',
  sortBy: 'presentation.sortBy',
  displayFields: 'presentation.displayFields',
  assignments: 'request.mappings',
  /** @deprecated Built-in override templates still persist this legacy presentation setting. */
  showNtpSeparately: 'presentation.showNtpSeparately',
} as const;
